<script setup lang="ts">
import { isExpand } from "@/views/Home/useData/useHomePage";
import publicStore from "@/store/publicStore";
import { storeToRefs } from "pinia";
import { openLoginDialog } from "@/components/Dialogues/useData/login";

const { isLogin } = storeToRefs(publicStore());
</script>

<template>
  <div>
    <div class="title" v-if="isExpand && !isLogin">
      请
      <div class="login" @click="openLoginDialog">登录</div>
      获取会话
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cover {
  width: 100%;
  height: 100%;
}

.title {
  margin-top: 40px;
  font-size: 14px;
  display: flex;
  font-weight: 500;
  .login {
    color: #4166d5;
    cursor: pointer;
  }
}
</style>
